/* eslint-disable import/prefer-default-export */
export const SET_FOLDERS_DATA = 'SET_FOLDERS_DATA';
export const UPDATE_NAME = 'UPDATE_NAME';
export const DUPLICATE_FOLDER = 'DUPLICATE_FOLDER';
export const SET_CURRENT_FOLDER_DATA = 'SET_CURRENT_FOLDER_DATA';
export const SET_CURRENT_FOLDER_PAGINATION = 'SET_CURRENT_FOLDER_PAGINATION';
